export const INVESTIGATION_ATTRIBUTES = {
  created_at: { title: "Started At", sortable: true, filterable: true },
  assigned_to: { title: "Assigned To", sortable: true, filterable: true },
  name: { title: "Name", sortable: true, filterable: true },
  priority: { title: "Priority", sortable: true, filterable: true },
  status: { title: "Status", sortable: true, filterable: true },
  updated_at: { title: "Last Update", sortable: true, filterable: true }
};
